import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import axios from "axios";
import {toFarsiNumber} from "../../cudtom-hooks/en-to-persian";
import {updatePending} from "../common-states/commonStatesSlice";

const config = {
    headers: {Authorization: `Token ${localStorage.getItem('token')}`}
}
export const getReportData = createAsyncThunk("report/getReportData", async(data) => {
    const {searchParam, filterStatus, pageNum, englishStartDate, englishEndDate, dispatch} = data
    let bodyArray = [];
    dispatch(updatePending(true))
    await axios.get(`https://demo.khedmatashayer-kj.ir/api/v1/nomad/tanker-request/${pageNum}?${filterStatus ? 'created_at' : 'start_created_at'}=${englishStartDate}&${filterStatus ? 'delivered_at' : 'end_created_at'}=${englishEndDate}&${searchParam}`, config)
        .then((res) => {
            console.log(res.data)
            res.data && res.data.forEach((item) => {
                let deliveredDate = new Date(item.nomad_confirmed_at).toLocaleDateString('fa-IR');
                let allocatedDate = new Date(item.driver_allocated_at).toLocaleDateString('fa-IR');
                let createdDate = new Date(item.created_at).toLocaleDateString('fa-IR');
                bodyArray = [...bodyArray, [item.nomad_confirmed_at ? deliveredDate : '-', item.driver ? item.driver.name : '-', item.driver_allocated_at ? allocatedDate : '-', createdDate,
                    item.water_volume, item.region, item.city, item.nomad.name, (item.water_type === 1 ? 'آب شرب' : 'آب دام')]]
            })
        })
        .catch(() => {
            alert('خطا در برقراری ارتباط با سرور')
        })
    let reportingBoxData = [];
    await axios.get(`https://demo.khedmatashayer-kj.ir/api/v1/nomad/tanker-request/filter?${filterStatus ? 'created_at' : 'start'}=${englishStartDate}&${filterStatus ? 'delivered_at' : 'end'}=${englishEndDate}&${searchParam}`, config)
        .then((res) => {
            let data = res.data;
            reportingBoxData = [
                [data.livestock_water_count, data.delivered_livestock_water_count, data.livestock_water, data.delivered_livestock_water, data.rejected_livestock_water_count],
                [data.drinkable_water_count, data.delivered_drinkable_water_count, data.drinkable_water, data.delivered_drinkable_water, data.rejected_drinkable_water_count],
                [data.livestock_water_count + data.drinkable_water_count, data.delivered_livestock_water_count + data.delivered_drinkable_water_count, data.livestock_water + data.drinkable_water, data.delivered_livestock_water + data.delivered_drinkable_water, data.rejected_livestock_water_count + data.rejected_drinkable_water_count]
            ] // Each item is for a special ReportsBoxColumn component.

            reportingBoxData = reportingBoxData.map((item) => {
                return item.map(item1 => {
                    return toFarsiNumber(item1)
                })
            })
        })
        .catch(() => {
            alert('خطا در برقراری ارتباط با سرور')
        })
    dispatch(updatePending(false))
    return {bodyArray, reportingBoxData}
})

const reportSlice = createSlice({
    name: 'report',
    initialState: {
        bodyArray: [],
        reportingBoxData: [],
    },
    reducers: {},
    extraReducers(builder){
        builder
            .addCase(getReportData.fulfilled, (state, action) => {
                return {...state, ...action.payload}
            })
    }
})

export const selectReportBodyArray = state => state.report.bodyArray
export const selectReportingBoxData = state => state.report.reportingBoxData

export default reportSlice.reducer